export default __webpack_public_path__ + "static/feature3-3998049a40415f499537c947cf5be0f4.jpg";